const config = {
	ChatGPTModel: 'gpt-3.5-turbo',
	HUBWorkerUrl: 'https://hub.cryptoaitrend.com',
};



export default config;